module.exports = __webpack_public_path__ + "static/media/transacciones-pendientes.89772300.svg";